<template>
    <footer class="py-[15px] border-t border-gray-200" :style="{ backgroundColor }">
        <div class="px-5 lg:px-[120px]">
            <div class="flex flex-col md:flex-row justify-between items-center gap-6">
                <router-link :to="logoLink" class="flex items-center gap-2">
                    <img class="w-[169px] h-[50px] object-contain" :src="$asset(logo, 'public')" alt="HKCM Logo" title="HKCM Logo" />
                </router-link>
                <div class="flex gap-0 text-[16px] font-semibold" :class="linkColor">
                    <router-link v-for="(link, index) in links" :key="index" :to="link.to" :class="linkClasses" class="px-5 py-[10px] hover:opacity-80">{{
                        link.text
                    }}</router-link>
                </div>
                <router-link
                    v-if="showCta"
                    :to="ctaLink"
                    class="text-white px-5 py-[10px] rounded-full text-[16px] font-semibold transition hover:opacity-90"
                    :style="{ background: `linear-gradient(to right, ${buttonGradientFrom}, ${buttonGradientTo})` }"
                >
                    {{ ctaText }}
                </router-link>
            </div>
        </div>
    </footer>
</template>

<script setup>
const props = defineProps({
    backgroundColor: {
        type: String,
        default: '#FFFFFF'
    },
    logo: {
        type: String,
        default: '/hkcm/images/logo-on-light-background.svg'
    },
    logoLink: {
        type: String,
        default: '/'
    },
    links: {
        type: Array,
        default: () => [
            { text: 'Impressum', to: '/impressum' },
            { text: 'AGB', to: '/agb' },
            { text: 'Datenschutz', to: '/datenschutz' }
        ]
    },
    linkColor: {
        type: String,
        default: 'text-gray-600'
    },
    ctaText: {
        type: String,
        default: 'Entdecken'
    },
    ctaLink: {
        type: String,
        default: '/'
    },
    showCta: {
        type: Boolean,
        default: true
    },
    buttonGradientFrom: {
        type: String,
        default: '#1E40AF'
    },
    buttonGradientTo: {
        type: String,
        default: '#1E3A8A'
    },
    fallbackCtaText: {
        type: String,
        default: ''
    },
    fallbackCtaBackgroundColor: {
        type: String,
        default: '#1E40AF'
    },
    linkClasses: {
        type: String,
        default: ''
    }
});
</script>
